import App from './../src/App.svelte';
import { initializeApp } from "firebase/app";
import {
	getAuth
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
	apiKey: firebaseAPIKey,
	authDomain: firebaseAuthDomain,
	projectId: firebaseProjectId,
	storageBucket: firebaseStorageBucket,
	messagingSenderId: firebaseMessageSenderId,
	appId: firebaseAppId,
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

const app = new App({
	target: document.body,
	props: {
		auth,
		firestore,
		firebaseApp
	}
});

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js')
			.then(registration => {
				console.log('Service Worker registered:', registration);
			})
			.catch(error => {
				console.error('Service Worker registration failed:', error);
			});
	});
}

export default app;